export default "__VITE_ASSET__Dn9sVeCM__"